/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';
import { EMode } from 'common/const/common.enum';

export interface ILegalEntityContext {
  editLegalEntityCardMode: EMode;
  setEditLegalEntityCardMode: (value: EMode) => void;
  openLegalEntityCard: boolean;
  setOpenLegalEntityCard: (value: boolean) => void;
  openEditLegalEntityCard: boolean;
  setOpenEditLegalEntityCard: (value: boolean) => void;
}

export const LegalEntityContext = createContext<ILegalEntityContext>({
  editLegalEntityCardMode: EMode.Create,
  setEditLegalEntityCardMode: () => {},
  openLegalEntityCard: false,
  setOpenLegalEntityCard: () => {},
  openEditLegalEntityCard: false,
  setOpenEditLegalEntityCard: () => {},
});
